import React from "react";
import { Box, Typography, TextField, Button, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

const CareersFormContainer = styled(Box)`
margin-bottom:26vw;
  @media (max-width: 768px) {
    padding-top: 3vw !important;
    margin-bottom: 0; 
  }
`;


const CareersFormContentWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 2vw 5vw 5vw;
  border-radius: 8px;
  position: relative;
  overflow: visible;
  @media (max-width: 768px) {
    padding: 2vw 7vw;
    flex-direction: column;
  }
`;

const BlueTypography = styled(Typography)`
  background-color: #1D00C4;
  color: #FFF;
  font-family: Radikal;
  font-size: 1.492rem;
  font-weight: 700;
  width: 100%;
  padding: 3vw 5vw;
  text-align: start;
  @media (max-width: 768px) {
    text-align: center;
    font-size: 1.313rem;
    padding: 6vw 5vw;
  }
`;

const CareersFormWrapper = styled(Paper)`
  padding: 4vw 3vw;
  position: absolute;
  transform: translateY(-15%);
  width: 50%;
  background: #FFF;
  border-radius: 0;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.15);
  @media (max-width: 768px) {
    position: relative;
    width: 100%;
    transform: none;
    padding: 4vw 5vw 7vw;
    transform: translateY(-12%);
  }


`;

const CareersFormStyledTextField = styled(TextField)`
  margin-bottom: 10px;

  & .MuiOutlinedInput-root {
    background-color: #EDEEFF;
    border-radius: 0 !important;
    box-shadow: none;
    display: flex;
    align-items: center;
  }

  & .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  & .MuiInputLabel-root {
    font-family: Radikal;
    font-weight: 400;
    font-size: 12px;
    color: #696A6D;
    margin-left: 6px;
  }

  & .MuiInputBase-input {
    font-family: Radikal;
    font-weight: 400;
    font-size: 12px;
    color: #696A6D;
    height: 0.9em;
    line-height: 1.5;
    display: block;
  }

  & .MuiInputLabel-root.Mui-focused {
    color: #1D00C4;
  }

  & .MuiInputBase-input:focus {
    color: #333;
  }
  & .MuiInputBase-root textarea {
    ::-webkit-scrollbar {
      width: 4px; 
    }
    
    ::-webkit-scrollbar-thumb {
      background-color: #1D00C4;  
      border-radius: 4px;
    }

    ::-webkit-scrollbar-track {
      background-color: #fff;
      border-radius: 4px;
    }
  }
`;

const ResumeUploadWrapper = styled(Box)`
  position: relative;
  width: 100%;
  margin-bottom:1vw;
  @media (max-width: 768px) {
    margin-bottom: 2.5vw;
  }
`;

const HiddenFileInput = styled("input")`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
`;

const StyledResumeField = styled(Box)`
  display: flex;
  align-items: center;
  background-color: #EDEEFF;
  border-radius: 0;
  padding: 12px;
  font-size: 12px;
  font-family: Radikal;
  color: #696A6D;
  width: 100%;
  cursor: pointer;
  padding-left: 1.5vw;
  @media (max-width: 768px) {
    padding-left: 3.5vw;
  }
`;


const StyledButton = styled(Button)`
  background-color: #1d00c4;
  color: #fff;
  padding: 0.5rem 3rem;
  text-transform: none;
  margin-top: 2rem;
  border: 0.9px solid #1d00c4;
  align-self: flex-end;
  position: relative;
  box-shadow: none;
  font-family: Radikal;
  font-size: 1.5rem;
  font-weight: 500;
  border-radius: 16px !important;

  &::after {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    border-radius: 15px;
    border: 3.5px solid #fff;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translateX(-50%);
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 20px;
  }

  @media (max-width: 768px) {
    font-size: 0.938rem;
    padding: 0.6rem 3rem;
  }
`;

const CareersForm = () => {

  const [resumeFile, setResumeFile] = React.useState("");

const handleFileChange = (event) => {
  const file = event.target.files[0];
  if (file) {
    setResumeFile(file.name); 
  } else {
    setResumeFile(""); 
  }
};
  return (
    <CareersFormContainer>
      <BlueTypography />
      <CareersFormContentWrapper>
        <CareersFormWrapper>
          <CareersFormStyledTextField fullWidth label="Full Name" />
          <CareersFormStyledTextField fullWidth label="Contact Number" />
          <CareersFormStyledTextField fullWidth label="Email" type="email"/>
          <ResumeUploadWrapper>
              <StyledResumeField>{resumeFile || "Resume"}</StyledResumeField>
              <HiddenFileInput type="file" accept=".pdf,.doc,.docx" 
              onChange={handleFileChange} />
          </ResumeUploadWrapper>

          <CareersFormStyledTextField
            fullWidth
            label="Please provide a brief summary about yourself (5-6 lines)."
            multiline
            rows={3}
          />
          <StyledButton variant="contained">Submit</StyledButton>
        </CareersFormWrapper>
      </CareersFormContentWrapper>
    </CareersFormContainer>
  );
};

export default CareersForm;
